<template>
    <div>
        <nav-bar :links="shelf.links"
                 :meta="shelf.meta"
                 :downloadStatus="downloadStatus">
        </nav-bar>
        <b-card-group d-block>
            <book-card @titleClick="titleClick"
                       v-for="b in shelf.books"
                       :book="b"
                       :key="b._id">
            </book-card>
        </b-card-group>
        <nav-bar :links="shelf.links"
                 :meta="shelf.meta"
                 :downloadStatus="downloadStatus">
        </nav-bar>
    </div>
</template>

<script>
    import BookCard from './BookCard.vue'
    import NavBar from './NavBar.vue'
    import {
        eventBus
    } from '../main';

    export default {
        props: [
            'searchQuery',
            'downloadStatus',
            'shelf'
        ],
        data: function() {
            return {
                book: {}
            }
        },
        methods: {
            titleClick(book) {
                this.$router.push('/book/' + book['_id'])
                this.$store.state.singleBook = false;
                this.$store.state.showModal = true;
            },
        },
        components: {
            BookCard,
            NavBar
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LibraryCovers.vue